import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"

import {products} from "../../../../data"
import Page from "../components/FixedBarPage"
import ScoopedCoolCard from '../components/ScoopedCoolCard'

import './TicketSelection.less'

class TicketSelection extends React.PureComponent {
  render() {
    const { product } = this.props
    
    return (
      <Page
        title="没票种类"
        containerProps={{ id: "ticketSelection" }}
      >

        <p>请选择门票</p>

        <ScoopedCoolCard product={product} url={`/catalogo/reservation/selections/${product._id}`}/>
        {product.relations && product.relations.includes.length > 0 && (
          <React.Fragment>
            {product.relations.includes.map(prd => (
              <ScoopedCoolCard key={prd} product={products[prd]} url={`/catalogo/reservation/selections/${prd}`}/>
            ))}
          </React.Fragment>
        )}
   
      </Page>
    )
  }
}

const mapStateToProps = (stateIgnored, ownProps) => {
  const product = products[ownProps.match.params.id] || products[encodeURIComponent(ownProps.match.params.id)]
  return {
    product,
  }
}

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TicketSelection)



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/TicketSelection.jsx